import React from "react"
import News1Photo from "../images/news1.jpg"
import News2Photo from "../images/news2.jpg"
import News3Photo from "../images/news3.jpg"
import News4Photo from "../images/news4.jpg"
const posts = [
  {
    title: "CR14 Open Cyber Range: a resource to trial cyber security tools",
    href: "https://e-estonia.com/c14-a-resource-to-trial-cyber-security-tools/",
    description:
      "The Estonian Ministry of Defense and several partners are developing a new resource called OCR to troubleshoot new cyber security products before they are deployed for use by the wider public. Companies and educators everywhere will eventually be able to access this resource and pilot their tools against known cyber threats and vulnerabilities in a virtual environment unavailable anywhere else today.",
    datetime: "2022-04-13",
    date: "Mar 10, 2022",
    image: News1Photo,
  },
  {
    title: "SACEUR Visits Red Teaming Exercise Crossed Swords in Estonia",
    href: "https://ccdcoe.org/news/2021/saceur-visits-red-teaming-exercise-crossed-swords-in-estonia/",
    description:
      "Yesterday, the Supreme Allied Commander Europe (SACEUR), General Tod D. Wolters visited Crossed Swords – unique full-spectrum training session to practice offensive cyber, including penetration testing and digital forensics. He was accompanied by the Director of the NATO Cooperative Cyber Defence Centre of Excellence (CCDCOE), Colonel Jaak Tarien.",
    date: "Mar 10, 2022",
    datetime: "2022-03-10",
    image: News2Photo,
  },
  {
    title: "Exercise for training offensive cyber operations kicks off!",
    href: "https://ccdcoe.org/news/2021/exercise-for-training-offensive-cyber-operations-kicks-off/",
    description:
      "The technical red teaming exercise Crossed Swords, focusing on experimentation with integrating kinetics and offensive cyber operations in the context of a modern battlefield, was executed for the 10th time today by the NATO Cooperative Cyber Defence Centre of Excellence (CCDCOE) in Tallinn",

    date: "Feb 12, 2022",
    datetime: "2022-02-12",
    image: News3Photo,
  },
  {
    title: "Cyber Coalition Executed from CR14 in Tallinn First Time Ever",
    href: "#",
    description:
      "NATO’s flagship exercise for improving collaboration within the alliance’s cyberspace domain, Cyber Coalition 2021, was executed today from the cyber competence centre CR14, which provides the virtual environment on its NATO Cyber Range for playing through technical scenario",

    date: "Jan 29, 2022",
    datetime: "2022-01-29",
    image: News4Photo,
  },
]

export default function LandingNewsSection() {
  return (
    <div className="bg-white pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
      <div className="relative max-w-lg mx-auto divide-y-2 divide-gray-200 lg:max-w-7xl">
        <div>
          <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
            News
          </h2>
          <div className="mt-3 sm:mt-4 lg:grid lg:grid-cols-2 lg:gap-5 lg:items-center">
            <p className="text-xl text-gray-500">
              Get weekly update from CR14 in you emailbox.
            </p>
            <form className="mt-6 flex flex-col sm:flex-row lg:mt-0 lg:justify-end">
              <div>
                <label htmlFor="email-address" className="sr-only">
                  Email address
                </label>
                <input
                  id="email-address"
                  name="email-address"
                  type="email"
                  autoComplete="email"
                  required
                  className="appearance-none w-full px-4 py-2 border border-gray-300 text-base rounded-md text-gray-900 bg-white placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 lg:max-w-xs"
                  placeholder="Enter your email"
                />
              </div>
              <div className="mt-2 flex-shrink-0 w-full flex rounded-md shadow-sm sm:mt-0 sm:ml-3 sm:w-auto sm:inline-flex">
                <button
                  type="button"
                  className="w-full bg-indigo-600 px-4 py-2 border border-transparent rounded-md flex items-center justify-center text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:w-auto sm:inline-flex"
                >
                  Notify me
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="mt-6 pt-10 grid gap-16 lg:grid-cols-2 lg:gap-x-5 lg:gap-y-12">
          {posts.map(post => (
            <div
              key={post.title}
              className=" flex flex-col  space-x-2  transform duration-300 ease-out scale-100 hover:scale-105  shadow-none hover:shadow-md pb-6"
            >
              <div>
                <img src={post.image} alt="" />
              </div>
              <div>
                {" "}
                <p className="text-sm text-gray-500">
                  <time dateTime={post.datetime}>{post.date}</time>
                </p>
                <a href="#" className="mt-2 block">
                  <p className="text-xl font-semibold text-gray-900">
                    {post.title}
                  </p>
                  <p className="mt-3 text-base text-gray-500">
                    {post.description}
                  </p>
                </a>
                <div className="mt-3">
                  <a
                    href={post.href}
                    className="text-base font-semibold text-indigo-600 hover:text-indigo-500"
                  >
                    Read full story
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
